export default __webpack_public_path__ + "static/media/copmany-doc-2.e4bb69b3.jpg";